module.exports = __webpack_public_path__ + "img/carnetB.93b0f8ca.png";